export default __webpack_public_path__ + "static/media/solucao-07.aefe365c.webp";